// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2UPuC","title":"InfoRow_title___CEQd"};